import { createStyles, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() =>
  createStyles({
    popper: {
      zIndex: 1
    },
    button: {
      fontSize: '1rem',
      color: '#1F1F1F'
    },
    menuItem: {
      fontSize: '.875rem',
      color: '#1F1F1F'
    }
  })
)
